import React, { useEffect, useState } from "react";
import "../workdetail/workdetail.scss";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import nophoto from "../../assets/no-photo.webp";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
const WorkDetailNew = ({ works, list }) => {
  const [villageList, setVillagelist] = useState([]);
  const [selectedName, setSelectedName] = useState("");
  const [villageWork, setVillageWork] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [data, setData] = useState([]);
  const fetchWorkDetail = async (id) => {
    try {
      const response = await axios.get(
        `https://backend.sambhajipatilnilangekar.com/api/villageworks/${id}/`
      );
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const filteredWorks = works.map((work) => ({
      id: work.id,
      start_date: work.start_date,
      end_date: work.end_date,
      village_name: work.village_name,
      sector_name: work.sector_name,
    }));
    setVillagelist(filteredWorks);
  }, [works]);

  console.log(villageList, "this is component work");

  const clickHandler = (myid) => {
    setToggle(true)
    fetchWorkDetail(myid);
  };

  const [search, setSearch] = useState("");
  const [popup, setPopup] = useState(false);

  useEffect(() => {
    if (villageList.length > 0) {
      const firstVillageId = villageList[0].id;
      fetchWorkDetail(firstVillageId);
    }
  }, [villageList]);

  function extractYear(dateString) {
    const year = dateString.split("-")[0];
    return year;
  }

  function formatToIndianCurrency(number) {
    let numStr = number.toString();
    let [integerPart, decimalPart] = numStr.split(".");
    let lastThreeDigits = integerPart.slice(-3);
    let otherDigits = integerPart.slice(0, -3);
    if (otherDigits !== "") {
      otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    }
    let formattedNumber =
      otherDigits + (otherDigits ? "," : "") + lastThreeDigits;
    return decimalPart ? `${formattedNumber}.${decimalPart}` : formattedNumber;
  }



  const fetchWorkByVillage = async () => {
    try {
      const response = await axios.get(
        `https://backend.sambhajipatilnilangekar.com/api/villageworks/villagename/?village_name=${selectedName}`
      );

      setVillageWork(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchWorkByVillage();
  }, [selectedName]);

  useEffect(() => {
    if (list.length > 0) {
      setSelectedName(list[0]);
    }
  }, [list]);
  return (
    <>
      <div className="workdetail-parent parent">
        <div className="workdetail-cont cont">
          <div className="left">
            <div className="input">
              <h2 style={{ color: "white" }}>गाव</h2>
            </div>
            <div className="village-list">
              {list
                .filter((item) =>
                  item.toLowerCase().includes(search.toLowerCase())
                )
                .map((item, index) => (
                  <div
                  className={selectedName == item ? `village active-village` :"village"}
                    key={index}
                    onClick={()=>setSelectedName(item)}
                  >
                    <p key={index}>{item}</p>
                  </div>
                ))}
            </div>
          </div>
          <div className="right">
            {!toggle ? (
              <div className="village-work-byname">
                {villageWork &&
                  villageWork.map((data, index) => {
                    return (
                      <div
                        className="village-name-box"
                        onClick={() => clickHandler(data.id)}
                        key={index}
                      >
                        <p>{data.work_desc} </p>{" "}
                        <span>
                          {data.start_date && extractYear(data.start_date)}
                          {data.end_date && ` - ${extractYear(data.end_date)}`}
                        </span>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <>
                <div className="top-heading">
                  <h3 className="title">
                    <span> {data.village_name}</span> येथे झालेली विकासकामे
                  </h3>
                  <div className="top-heading-btn-box">
                    {/* <button onClick={()=>close()} className="btnz">
                      नकाशा पहा
                    </button> */}
                    <button onClick={() => setToggle(false)} className="btnz">
                      परत जा
                    </button>
                  </div>
                </div>
                <div className="details-village">
                  {data.images && data.images.length > 0 ? (
                    <Swiper
                      pagination={{
                        clickable: true,
                      }}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }}
                      modules={[Pagination, Navigation, Autoplay]}
                      className="village-image-swiper"
                    >
                      {data.images.map((item, index) => (
                        <SwiperSlide
                          className="work-image bg-img-cover"
                          style={{ background: `url(${item.image})` }}
                          key={index}
                        ></SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <div
                      className="work-image placeholder-no-photo"
                      style={{ background: `url(${nophoto})` }}
                    ></div>
                  )}

                  <div className="details-work-details">
                    {data.start_date && (
                      <span className="btn-active2">
                        दिनांक : {extractYear(data.start_date)}
                        {data.end_date && `- ${extractYear(data.end_date)}`}
                      </span>
                    )}
                    {data.sector_name && (
                      <span className="btn-active2">
                        क्षेत्र : {data.sector_name}{" "}
                      </span>
                    )}
                    {data.work_budget && (
                      <span className="btn-active2">
                        रक्कम : ₹{" "}
                        {data.work_budget &&
                          formatToIndianCurrency(data.work_budget)}{" "}
                      </span>
                    )}
                    {data.work_desc && (
                      <span className="btn-active2">{data.work_desc}</span>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {popup && (
        <div className="popup" onClick={() => setPopup(false)}>
          <div className="left">
            <div className="input">
              <input
                type="text"
                placeholder="search the village"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="village-list">
              {villageList
                .filter((item) =>
                  item.title.toLowerCase().includes(search.toLowerCase())
                )
                .map((item, index) => (
                  <div className="village">
                    <p key={index} onClick={() => setPopup(false)}>
                      {item.title}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WorkDetailNew;
